import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'tasks',
  title: '任务',
  /* 后端 task 模块强制依赖 arch + product（TabCounts 用 ArchService、需求登记），
     前端对齐补齐，避免菜单出现无路由的产研/架构入口 */
  dependsOn: ['architecture', 'solution'],
  routes: [
    { path: '/tasks', name: 'tasks', component: () => import('./TaskListView.vue'), meta: { tab: 'task' } },
  ],
} satisfies FeatureModule
